import SectionHeading from "@/components/base/SectionHeading";
import { tvs } from "@/mocks/tvs";
import { getDetailRoute } from "@/utils/media";

export default function LatestTv() {
  const latest = [...tvs].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeading
          title="最新电视剧更新"
          subtitle="追更不迷路，实时同步各剧集更新进度"
          actionLabel="查看全部剧集"
          actionHref="/category/tv"
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
          {latest.map((tv) => {
            const progress = Math.min(100, Math.round((tv.updatedTo / tv.episodeCount) * 100));
            return (
              <a
                key={tv.id}
                href={getDetailRoute("tv", tv.id)}
                className="group flex gap-4 p-3 rounded-lg bg-background-100 ring-1 ring-background-200/70 hover:ring-accent-500/50 transition-all cursor-pointer"
              >
                <div className="relative w-24 h-32 md:w-28 md:h-36 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={tv.poster}
                    alt={`${tv.title}海报`}
                    title={`${tv.title} - 天堂电影网`}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute bottom-1 left-1 rounded bg-background-50/85 px-1.5 py-0.5 text-[10px] font-medium text-accent-300">
                    更新至{tv.updatedTo}集
                  </span>
                </div>
                <div className="flex-1 min-w-0 flex flex-col">
                  <div className="flex items-start justify-between gap-2">
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-accent-400 transition-colors line-clamp-1">
                      {tv.title}
                    </h3>
                    <span className="inline-flex items-center gap-0.5 shrink-0 text-sm font-semibold text-accent-300">
                      <i className="ri-star-fill text-accent-400" aria-hidden="true" />
                      {tv.rating.toFixed(1)}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-500">
                    {tv.year} · {tv.country} · {tv.genres.slice(0, 3).join(" / ")}
                  </p>
                  <p className="mt-2 text-xs md:text-sm text-foreground-400 leading-relaxed line-clamp-2">{tv.description}</p>
                  <div className="mt-auto pt-3">
                    <div className="flex items-center justify-between text-[11px] text-foreground-500 mb-1.5">
                      <span>
                        更新至 {tv.updatedTo} / {tv.episodeCount} 集
                      </span>
                      <span>{progress}%</span>
                    </div>
                    <div className="h-1.5 w-full rounded-full bg-background-300/60 overflow-hidden">
                      <div className="h-full rounded-full bg-accent-500" style={{ width: `${progress}%` }} />
                    </div>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}